// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-list-cta .item-icon[data-v-5c4393d9] {\n  transition: 0.3s ease-in-out;\n}\n.custom-list-cta:hover .item-icon[data-v-5c4393d9] {\n  transform: scale(1.2);\n}\n.custom-list-cta .icon[data-v-5c4393d9] {\n  transition: 0.3s ease-in-out;\n  margin-right: 10px;\n  opacity: 0.5;\n}\n.custom-list-cta:hover .icon[data-v-5c4393d9] {\n  margin-right: 0;\n  opacity: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
